<template>
  <sweet-modal ref="pdf_preview_modal" blocking="blocking" width="80%">
    <div>
      <div class="embed-responsive embed-responsive-1by1">
        <iframe class="embed-responsive-item" :src="base64_src"></iframe>
      </div>
    </div>
  </sweet-modal>
</template>
<script>
export default {
  data: function () {
    return {
      pdf_data: null
    };
  },
  computed: {
    base64_src() {
      return 'data:application/pdf;base64,' + this.pdf_data;
    }
  },
  methods: {
    open(pdf_data) {
      this.pdf_data = pdf_data;
      this.$refs.pdf_preview_modal.open();
    }
  }
};
</script>
